export enum HEATMAP_GENERATION_FAILURE_ERRORS {
  SCREENSHOT_GENERATION_FAILURE = 'screenshot_generation_failure',
  HEATMAP_GENERATION_FAILURE = 'heatmap_generation_failure',
  NO_HEATMAP_DATA_FOUND = 'no_heatmap_data_found',
  NO_HEATMAP_DATA_CHECK_TRACKING = 'no_heatmap_data_check_tracking',
  NO_HEATMAP_DATA_INCREASE_COVERAGE = 'no_heatmap_data_increase_coverage',
  TRACKING_CODE_INSTALLED_NO_SESSIONS = 'tracking_code_installed_no_sessions',
  NO_SESSIONS_FOR_URL = 'no_sessions_for_url',
  REGEX_MATCH_NOT_SUPPORTED = 'regex_match_not_supported',
  CANCELLED = 'cancelled',
}
